<template>
  <div
    v-if="tabList.length>0"
    ref="aside"
    :style="{width:isOpen?'275px':'0px'}"
    class="aside-content"
  >
    <ul class="main-aside">
      <li
        v-for="(tab) in tabList"
        :key="tab.id"
        :class="{'chosenFirst':grandpaMenu&&(grandpaMenu.id == tab.id)}"
        class="main-tab g-flex"
        @click="switchTabFir(tab)"
      >
        <span>{{ tab.label }}</span>
      </li>
    </ul>
    <div class="sub-menu-container">
      <ul class="submain-aside">
        <p class="submain-title">{{ grandpaMenu&&(grandpaMenu.label) }}</p>
        <li
          v-for="(subtab, index) in subTabList"
          :key="index"
          class="submain-tab"
        >
          <span
            :class="{focus:currentParentMenu.id == subtab.id}"
            class="vice_nav_title"
            @click="setSubSubIndex(index)"
          ><i
            v-if="subTabList[index].children&&subTabList[index].children.length>0"
            :class="{'el-icon-arrow-up':viceNavIndex == index,'el-icon-arrow-down':!(viceNavIndex == index)}"
          /> {{ subtab.label }}</span>
          <ul
            v-if="subTabList[index].children"
            :style="{'height':viceNavIndex == index ? subTabList[index].children.length*56+'px' : '0px'}"
            class="cc_wrapper"
          >
            <li
              v-for="(item,index2) in subTabList[index].children"
              :key="index2"
              :class="{__active:currentSubMenu&&currentSubMenu.url == item.url}"
              @click="setRoute(item.url)"
            >{{ item.label }}</li>
          </ul>
        </li>
      </ul>
    </div>
    <span
      v-if="subTabList.length"
      class="open-control"
      @click="isOpen=!isOpen"
    >
      <i
        class="iconfont"
        v-html="isOpen? '&#xe74f;': '&#xe70c;'"
      />
    </span>
  </div>
</template>

<script>
  import emitter from '../../mixins/emitter.js';

  export default {
    name: 'l-aside',
    mixins: [emitter],
    data() {
      return {
        isOpen: true,
        mouseEnter: false,
        transitionStart: false,
        viceNavOpenIndex: -1,
        subTabList: [],
        grandpaMenu: {},
        currentParentMenu: {},
        currentSubMenu: {},
        viceNavIndex: -1, // 3级导航
      };
    },
    computed: {
      tabList() {
        return this.$store.getters.menuList;
      },
    },
    watch: {
      '$route': {
        handler(newName, oldName) {
          this.computedSubList(newName, oldName);
        },
      },
      isOpen(v) {
        this.dispatch('layOut', 'isAsideOpen', [v]);
      }
    },
    mounted() {
      this.computedSubList(this.$route);
    },
    methods: {
      computedSubList(newName, oldName) {
        this.subTabList = [];
        this.grandpaMenu = {};
        this.currentSubMenu = {};
        this.currentParentMenu = {};
        let grandpaMenu = this.tabList.find((item, index) => {
          let subItem = item.children;
          let currentParentMenu = subItem.find(itemChild => {
            if (itemChild.url == newName.path) {
              return itemChild;
            } else {
              let mychilChild = itemChild.children.find(childChild => {
                if (childChild.url == newName.path) {
                  this.currentSubMenu = childChild;
                  return true;
                }
              });
              if (mychilChild) {
                return true;
              }
            }
          });
          if (currentParentMenu) {
            this.currentParentMenu = currentParentMenu;
            return true;
          }
        });
        if (grandpaMenu) {
          this.grandpaMenu = grandpaMenu;
          this.subTabList = grandpaMenu.children;
        }
      },
      switchTabFir(tab) {
        let url = '';
        if (tab.children.length > 0) {
          let subChild = tab.children[0].children;
          url = subChild.length > 0 ? subChild[0].url : tab.children[0].url;
        }
        if (tab.id != this.grandpaMenu.id) { // 未切换菜单的时候
          this.$router.push(url);
        }
        this.isOpen = true;
      },
      switchTabSec(subtab) {
        this.$router.push(subtab.url);
      },
      setRoute(path) {
        this.$router.push(path);
      },
      setSubSubIndex(index) {
        if (this.subTabList[index].children && this.subTabList[index].children.length > 0) {
          this.viceNavIndex == index ? this.viceNavIndex = -1 : this.viceNavIndex = index;
        } else {
          this.setRoute(this.subTabList[index].url);
        }
      }
    }
  };

</script>

<style lang="scss" scoped>
  ul {
    list-style: none;
  }
  .focus {
    background: #289cef;
    color: #fff;
  }
  .__active {
    background: #3688c3;
    color: #ffffff !important;
  }
  .tttt::before {
    content: "\e603";
    color: #ffffff;
  }

  .cc_wrapper {
    background: #57687f;
    -webkit-transition: 400ms ease;
    -moz-transtion: 200ms ease;
    transition: 200ms ease;
    overflow: hidden;
    li:hover {
      cursor: pointer;
      background: #3688c3;
      color: #ffffff;
    }
  }
  .aside-content {
    position: relative;
    height: calc(100vh - 60px);
    display: flex;
    transition: 0.5s;
    ::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }

    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }

  .main {
    &-aside {
      height: calc(100vh - 60px);
      background-color: #314157;
      float: left;
      cursor: pointer;
      overflow-y: auto;
      z-index: 8;
      transition: 0.5s;
      width: 60px;
      padding-top: 20px;
      width: 126px;
      overflow-y: auto;
    }
    &-tab:hover {
      background: #289cef;
      color: #fff;
    }
    &-tab {
      color: #86aac3;
      cursor: pointer;
      position: relative;
      height: 60px;
      line-height: 60px;
      padding: 0 14px;
      overflow: hidden;
      i {
        font-size: 22px;
        line-height: 60px;
        text-align: center;
      }

      span {
        font-size: 14px;
        text-align: center;
        margin-bottom: 16px;
        text-indent: 10px;
        text-align: left;
        /* width: 140px; */
        transition: 0.5s;
      }

      &.chosenFirst {
        background: #289cef;

        span {
          color: #fff;
        }

        i {
          color: #fff;
        }
      }
    }
  }

  .sub-menu-container {
    height: 100%;
    transition: 0.5s;
    overflow: auto;
  }

  .submain {
    &-aside {
      width: 155px;
      height: 100%;
      background-color: #42546c;
      cursor: pointer;
      overflow-y: scroll;
    }

    &-tab span:hover {
      background: #289cef;
      color: #fff;
    }
    &-tab.focus {
      background: #289cef;
      color: #fff;
    }
    &-tab {
      line-height: 56px;
      /* text-indent: 25px; */
      /* padding-left: 10px; */
      font-size: 14px;
      color: #bccbd6;
      position: relative;
      overflow: hidden;
      .vice_nav_title {
        display: inline-block;
        height: 100%;
        width: 100%;
        padding-left: 20px;
      }
      span {
        transition: 0.5s;
      }
      u {
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 56px;
        background: #289cef;
      }

      i {
        /* position: absolute; */
        top: 0;
        right: 20px;
      }

      .iconRotate {
        transform: rotate(180deg);
        right: -5px;
      }

      ul {
        text-indent: 20px;
        li {
          color: #bccbd6;
          font-size: 14px;

          &.chosenthird {
            background: #50617a;
            color: #fff;
          }
        }
      }
    }
  }

  .open-control {
    display: block;
    width: 24px;
    height: 64px;
    background-color: #289cef;
    line-height: 64px;
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    text-align: center;
    z-index: 99;

    i {
      color: #fff;
    }
  }

  .submain-aside {
    padding-top: 50px;
    white-space: nowrap;
    box-sizing: border-box;
    /* transition: all 0.5s; */

    .submain-title {
      font-size: 18px;
      color: #bccbd6;
      line-height: 25px;
      margin-bottom: 36px;
      padding-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/aside/aside.vue